'use client';
import React, { useRef, useState } from 'react';
import { ApiAttribute } from '@context/openapi/types';
import InputFieldContainer from '@components/ui/DynamicForm/InputFieldContainer';
import InputField from '@components/ui/DynamicForm/InputField';
import InputLabel from '@components/ui/DynamicForm/InputLabel';

interface StringInputProps {
  field: ApiAttribute;
  onChange: (field: ApiAttribute, value: string) => void;
  fieldNameOverride?: string;
}

export const Input: React.FC<StringInputProps> = ({
  field,
  onChange,
  fieldNameOverride,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [_isHelpVisible, setIsHelpVisible] = React.useState(false);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <InputFieldContainer field_key={field.key}>
      <div className={`flex w-full pl-2 group cursor-pointer bg-[#d3e4e6]`}>
        <InputLabel field={field} fieldNameOverride={fieldNameOverride} />
        <InputField
          ref={inputRef}
          field={field}
          isFocused={isFocused}
          setIsFocused={setIsFocused}
          onChange={onChange}
          onHelpVisible={(state: boolean) => {
            setIsHelpVisible(state);
          }}
        />
      </div>
    </InputFieldContainer>
  );
};

export default Input;
